import axios from "axios";
import { Config } from "../config";

interface ApiResponse {
  data: {
    data: string[];
    response:string[];
  };
}


export const GetFavoriteProduct = async (
  limit: string,
  token: string,
  product: string
) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      maxBodyLength: Infinity,
      url:
        Config.apiEndpoint +
        `product/get-product-home-best-seller?limit=${limit}&product_type=${product}`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json"
      }
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // }
  }
};


export const GetProductFavorite = async (token: string) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `product/get-favorite`,
      headers: {
        "accept-language": "th",
        "x-access-token": token,
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json"
      }
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // }
  }
};